import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { supabase } from '@/lib/supabase';

export type OAuthProvider = 'google' | 'apple';

/**
 * Start a Google/Apple OAuth sign-in, platform-aware.
 *
 * On web, Supabase navigates the page to the provider and `detectSessionInUrl`
 * finishes the flow when it redirects back to `/auth/callback`.
 *
 * On native (Capacitor), there is no page load at the custom-scheme redirect, so
 * we open the provider URL ourselves in an in-app browser and let the
 * `appUrlOpen` deep-link listener (see `useOAuthDeepLink`) finish the exchange.
 */
export async function startOAuth(provider: OAuthProvider, redirectTo: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider,
      options: {
        redirectTo,
        skipBrowserRedirect: true,
      },
    });
    if (error) throw error;
    if (data?.url) {
      await Browser.open({ url: data.url });
    }
    return;
  }

  const { error } = await supabase.auth.signInWithOAuth({
    provider,
    options: {
      redirectTo,
    },
  });
  if (error) throw error;
}
